import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { useSelector } from 'react-redux';

import { Select, Form } from 'ui/components';

import { SkeletonText, SkeletonsForm, Skeletons } from 'ui/components/skeleton';

const initialState = {
  items: [
    {
      id: null,
      item: null,
      item_id: null,
      fraction: null,
      fraction_id: null,
      quantity: null,
    },
  ],
};

export const FormItems = ({ data, isLoading,  onItemChange }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [{ items }, setState] = React.useState(initialState);

  const $handleItemsChange = async (i, e, name) => {
    let newItems = [...items];

    if (e?.target?.name) {
      newItems[i][e.target.name] = e.target.valueNumber;
    } else {
      newItems[i][`${name}_id`] = e?.id;
      newItems[i][name] = e;
    }

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          item: null,
          item_id: null,
          fraction: null,
          fraction_id: null,
          quantity: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    newItems.splice(i, 1);

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  React.useEffect(() => {
    const state = {
      items,
    };

    onItemChange(state);
  }, [items]);

  React.useEffect(() => {
    if (!data) return;

    let b = [];
    if (data) {
      data?.items?.forEach((i) => {
        b.push({
          id:i?.id,
          item: i?.item,
          item_id: i?.item?.id,
          fraction: i?.fraction,
          fraction_id: i?.fraction?.id,
          quantity: i?.quantity_planned / i?.fraction?.quantity,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [data]);

  React.useEffect(() => {
    if (data) return;

    setState({items: [
      {
        id: null,
        item: null,
        item_id: null,
        fraction: null,
        fraction_id: null,
        quantity: null,
      },
    ],});
  }, [])

  return (
    <div>
      <div
        className="fw-semibold py-2 border-bottom mb-3"
        style={{ fontSize: 13 }}
      >
        {isLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Daftar Item'
        )}
      </div>

      {isLoading ? (
        <>
          <div className="row padding-20 rounded-2 border">
            <div className="col-md-4">
              <SkeletonsForm count={1} />
            </div>
            <div className="col-md-4">
              <SkeletonsForm count={1} />
            </div>
            <div className="col-md-4">
              <SkeletonsForm count={1} />
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <Skeletons height={30} />
          </div>
        </>
      ) : (
        <>
          {items?.map((e, i) => (
            <div
              className={cn(
                'px-3 py-3 mb-3 border rounded position-relative',
                StateForm?.errors?.items ? 'border-danger' : ''
              )}
              key={i}
            >
              <div className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center">
                {items?.length > 1 && (
                  <div className="p-1">
                    <Fi.FiX
                      color="red"
                      size={20}
                      onClick={() => $removeField(i)}
                      className="cursor-pointer"
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className='col-md-6'>
                  <div className="mb-3">
                    <Select.Remote
                      required
                      label="Pilih Item"
                      placeholder=""
                      url="/wms/item"
                      value={e?.item?.id}
                      initialValue={e?.item?.id}
                      params={{ order_by: 'id', is_active: 'active' }}
                      row={(d) => {
                        return {
                          value: d.id,
                          label: d.alias_name,
                        };
                      }}
                      keys={e?.item?.id}
                      onSelected={(e) => $handleItemsChange(i, e, 'item')}
                      errors={
                        StateForm?.errors[`items.${i}.item_id`]
                      }
                    />
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className="mb-3">
                    <Select.Remote
                      required
                      label="Pilih Fraction"
                      placeholder=""
                      url={`/wms/item/${e?.item?.id}/fractions`}
                      value={e?.fraction?.id}
                      initialValue={e?.fraction?.id}
                      row={(d) => {
                        return {
                          value: d.id,
                          label: d.name,
                        };
                      }}
                      onSelected={(e) => $handleItemsChange(i, e, 'fraction')}
                      keys={e?.item?.id}
                      disabled={!e?.item_id}
                      errors={
                        StateForm?.errors[`items.${i}.fraction_id`]
                      }
                    />
                  </div>
                </div>
                <div className='col-md-3'>
                  <Form.Input
                    required
                    autoComplete="off"
                    label="Jumlah"
                    name="quantity"
                    type="number"
                    value={e?.quantity}
                    onChange={(e) => $handleItemsChange(i, e)}
                    error={
                      StateForm?.errors?.quantity ||
                      StateForm?.errors[`items.${i}.quantity`]
                    }
                  />
                </div>
              </div>
              {StateForm?.errors?.items && (
                <div className="invalid-feedback d-block ">
                  {StateForm?.errors?.items}
                </div>
              )}
            </div>
          ))}
          <button
            type="button"
            className="btn btn-primary rounded mb-3"
            style={{ minHeight: 36, minWidth: '100%' }}
            onClick={() => $addMoreFields()}
          >
            <Fi.FiPlus className="me-2" /> Tambah Item
          </button>
        </>
      )}
    </div>
  );
};
